import { render, staticRenderFns } from "./Relacionamentos.vue?vue&type=template&id=77226bb0&scoped=true&"
import script from "./Relacionamentos.vue?vue&type=script&lang=js&"
export * from "./Relacionamentos.vue?vue&type=script&lang=js&"
import style0 from "./Relacionamentos.vue?vue&type=style&index=0&id=77226bb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77226bb0",
  null
  
)

export default component.exports